// extracted by mini-css-extract-plugin
module.exports = {"bingo":"bingoGrid_bingo__2Yplm","elem":"bingoGrid_elem__3Liue","elem1":"bingoGrid_elem1__1rxmy","gridLayout":"bingoGrid_gridLayout__2SzKc","gridElem":"bingoGrid_gridElem__aHZAv"};